import React, { createContext, useContext, useMemo } from 'react';
import type { AppAction, AppState } from '../types';



// Context Setup
const AppStateContext = createContext<{
  state: AppState;
  dispatch: React.Dispatch<AppAction>;
} | null>(null);

const useAppState = () => {
  const context = useContext(AppStateContext);
  if (!context) {
    throw new Error('useAppState must be used within AppStateProvider');
  }
  return context;
};

const useSelector = <T,>(selector: (state: AppState) => T): T => {
  const { state } = useAppState();
  return useMemo(() => selector(state), [state, selector]);
};

const useDispatch = () => {
  const { dispatch } = useAppState();
  return dispatch;
};

export { AppStateContext, useAppState, useSelector, useDispatch };
export type { AppState, AppAction };